import { query } from '@ember-data/json-api/request';
import type { Store } from '@ember-data/store/-private';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AuthOrdersAcceptRoute extends Route {
  @service declare store: Store;
  async model(params) {
    const id = params.id;
    await this.store.request(
      query('order-entry', {
        'filter[order]': id,
      })
    );
    const model = this.store.peekRecord('order', id);
    return model;
  }
}
